// extracted by mini-css-extract-plugin
export default {"app":"app_app__EbMYO","sidebar":"app_sidebar__9hCZE","content":"app_content__hfDIT"};